module.exports = __webpack_public_path__ + "img/head-quotation-mark.8a191fcf.png";